export default __webpack_public_path__ + "static/media/tt_logo_tm_color_rgb.942c2636.png";